import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import {
  SubmitNumberPayload,
  SubmitSmsNumber
} from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitSmsNumberService {
  submitSmsNumberHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.submitSmsTarget+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  SubmitSMSNumber = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    phone: string
  ): Observable<SubmitSmsNumber> => {
    const getSubmitSmsNumber = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitSmsNumberUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getSubmitSmsNumber
      }
    ];

    const payload: SubmitNumberPayload = {
      phone: phone
    };

    return new ApiBuilder<SubmitNumberPayload, SubmitSmsNumber>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitSmsNumberUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.submitSmsNumberHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_SMS_NUMBER_SERVICE')
      .withCredentials(true)
      .create();
  };
}
